import Grid from '@material-ui/core/Grid'
import React, { FC } from 'react'

//* utils
import { paddingSizes } from '../../../constants/contentfulStyle.constant'
import { ComponentIconsText } from '../../../models/components/iconText'
import { TopicIconText } from '../../../models/topics/iconText'

//* styles
import GlobalContainer from '../globalContainer'
import { IconsContainer } from './style'

//* components
import { IconText } from './subcomponent'

type Props = {
  data: ComponentIconsText
}

const Icons: FC<Props> = ({ data }) => {
  const iconTextData = {
    theme: data.theme || 'Light',
    topPadding: data.topPadding || paddingSizes.NONE.name,
    bottomPadding: data.bottomPadding || paddingSizes.LARGE.name,
    layout: data.layout || 'Text to Right',
    rowMax: data.rowMax || '2',
    icons: data.icons || null,
    useCase: data.useCase || null,
  }

  let property = {}
  const UseCaseValues = {
    FULL_WIDTH: 'Full width',
    EVENTS: 'Events',
  }

  const RowMaxValues = {
    TWO: '2',
    THREE: '3',
    FOUR: '4',
    FIVE: '5',
    SIX: '6',
  }

  if (iconTextData.useCase === UseCaseValues.FULL_WIDTH) {
    if (iconTextData.rowMax === RowMaxValues.FOUR) {
      property = {
        xs: 12,
        sm: 6,
        md: 3,
      }
    } else {
      property = {
        xs: 12,
        sm: 6,
        md: 4,
      }
    }
  } else if (iconTextData.rowMax === RowMaxValues.TWO) {
    property = {
      xs: 12,
      sm: 6,
      md: 6,
    }
  } else if (iconTextData.rowMax === RowMaxValues.THREE) {
    property = {
      xs: 12,
      sm: 6,
      md: 4,
    }
  } else if (iconTextData.rowMax === RowMaxValues.FOUR) {
    property = {
      xs: 12,
      sm: 6,
      md: 3,
    }
  } else if (iconTextData.rowMax === RowMaxValues.FIVE) {
    property = {
      xs: 6,
    }
  } else if (iconTextData.rowMax === RowMaxValues.SIX) {
    property = {
      xs: 6,
      sm: 2,
      md: 2,
    }
  }
  if (iconTextData.useCase === UseCaseValues.EVENTS) {
    iconTextData.theme = 'Light'
    if (
      iconTextData.rowMax === RowMaxValues.TWO ||
      iconTextData.rowMax === RowMaxValues.THREE ||
      iconTextData.rowMax === RowMaxValues.FOUR ||
      iconTextData.rowMax === RowMaxValues.FIVE ||
      iconTextData.rowMax === RowMaxValues.SIX
    ) {
      property = {
        xs: 12,
        sm: 6,
        md: 4,
      }
    }
  }

  return (
    <IconsContainer
      $topPadding={iconTextData.topPadding}
      $bottomPadding={iconTextData.bottomPadding}
      $background={iconTextData.theme}
      $layout={iconTextData.layout}
      $columns={iconTextData.rowMax}
      data-cy="icons"
      className={iconTextData.useCase === 'Full width' ? 'IconText__fullWidth' : ''}>
      <GlobalContainer
        className={`Icons__Outer-Container ${
          iconTextData.useCase === 'Full width' ? 'IconText--fullWidth' : ''
        } ${
          iconTextData.useCase === 'Events'
            ? `IconText--Events IconsLength${iconTextData.icons.length}`
            : ''
        }`}>
        <Grid container className="Icons__Inner-Container" spacing={3}>
          {iconTextData.icons
            ?.slice(
              0,
              iconTextData.useCase === 'Events' ? 6 : iconTextData.icons.length // Show 6 icons only if useCase is 'Events'
            )
            .map((item: TopicIconText, index: number) => (
              <IconText key={index} property={property} item={item} iconTextData={iconTextData} />
            ))}
        </Grid>
      </GlobalContainer>
    </IconsContainer>
  )
}

export default Icons
